<div class="feedback-comment">
    <div class="text">
        <div class="title my-color-blue" [innerHTML]="title | safeHtml"></div>
    </div>

    <div *ngIf="!!description" class="text"><strong>{{description}}</strong></div>
    <div class="body-text" [innerHTML]="details.output"></div>
</div>
